<template>
  <BaseTab id="facts">
    <v-subheader>Facts</v-subheader>
    <div />
    <v-text-field
      v-model="addFactText"
      class="mx-auto add-fact-field"
      placeholder="Add a Fact..."
      @keydown.enter="handleAddFact"
      rounded
      filled
      flat
      solo-inverted
      :disabled="currentlyViewedChallenge.archived"
    />
    <v-list two-line>
      <template v-for="(fact, i) in facts">
        <Fact
        :key="i"
        :fact="fact" />
      </template>
    </v-list>
  </BaseTab>
</template>

<script>
import BaseTab from '@/components/base/BaseTab'
import Fact from './Fact'
import interact from 'interactjs'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'FactsList',

  data: () => ({
    addFactText: '',
    windowHeight: window.innerHeight
  }),

  components: {
    BaseTab,
    Fact
  },

  async created () {
    await this.requestAllFacts()
  },

  computed: {
    ...mapState({
      facts: state => state.canvas.facts.facts,
      currentlyViewedChallenge: state => state.challenge.currentlyViewedChallenge
    })
  },

  methods: {
    ...mapActions('canvas', [
      'requestAllFacts',
      'requestCreateFact'
    ]),

    handleAddFact () {
      if (this.addFactText !== '') {
        // trim leading + trailing whitespace
        const factText = this.addFactText.trim()
        this.requestCreateFact(factText)
        this.addFactText = ''
      }
    }
  },
  mounted () {
    interact('#facts').dropzone({})
  }
}
</script>

<style lang="sass" scoped>
  #facts
    z-index: 1

  .add-fact-field
    width: 250px
    top: 1em
</style>
